<template>
  <div class="resume-rooms">
    <p class="resume-rooms__title semibold">La tua scelta:</p>
    <resume-item
      v-for="(room, room_index) in selected_solution.rooms"
      :key="_uid+'_solution_rooms_'+room_index"
    >
      <template v-slot:label_sx><span class="resume-rooms__label semibold">{{ get_total(room.products, 'qty') + 'x' }}</span></template>
      <template v-slot:label_dx><span class="resume-rooms__label resume-rooms__label--rooms">{{ room.name }}</span></template>
    </resume-item>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { number, sum } from "mathjs"
import ResumeItem from "@bookingv3/components/blocks/resume/resume-item"

export default {
  name: 'resume',

  components: {
    'resume-item': ResumeItem,
  },

  props: {

  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // stato del modulo livebkv3
      selected_solution: state => state.livebkv3.selected_solution,
    }),
  },

  created() {
  },

  mounted() {
  },

  methods: {

    // Ritorna la quantità totale(camere, live_price)
    get_total(products, keyword) {
      return Object.values(products)
        .map(product => number(product.price_selected[keyword] || 0))
        .reduce((total, price) => sum(total, price), 0)
    }

  },
}
</script>

<style lang="scss" scoped>

  .resume-rooms {
    padding-bottom: 5px;
    border-bottom: 1px solid $gray-400;
    margin-bottom: 5px;

    &__label {

      &--rooms {
        margin-bottom: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 10px;
      }
    }
  }

</style>